import { useMemo, useState } from 'react'
import { BasketAddonItem } from './BasketAddonItem'
import { useCartPlugin } from '@/features/cart/hooks'
import { GiftWrapPlugin, UnderwearCareBagPlugin } from '@/features/cart/plugins'
import type { AddonProduct } from './types'
import { BasketAddonButton } from './BasketAddonButton'
import { Icon, Popover, Text, Transition } from '@lounge-fe/ui-kit'

export const BasketAddonPopover: React.FC = () => {
  const plugin = useCartPlugin()

  const [activeProduct, setActiveProduct] = useState<AddonProduct | undefined>()
  const [queuedProduct, setQueuedProduct] = useState<AddonProduct | undefined>()

  const enabledProducts = useMemo(() => {
    const giftWrapPlugin = plugin(GiftWrapPlugin)
    const underwearCareBagPlugin = plugin(UnderwearCareBagPlugin)

    const enabledProducts = []

    if (underwearCareBagPlugin?.enabled) {
      enabledProducts.push(underwearCareBagPlugin.getProduct())
    }

    if (giftWrapPlugin?.enabled) {
      enabledProducts.push(giftWrapPlugin.getProduct())
    }

    return enabledProducts
  }, [plugin])

  return (
    <Popover exclusive>
      {({ isOpen, onOpen, onClose }) => (
        <>
          <Popover.Backdrop className="-z-10 absolute backdrop-blur-sm bg-black/[0.3]" />
          <div className="relative">
            <Transition.Slide
              direction="bottom"
              className="w-full absolute bottom-full bg-white -z-10"
              onAnimationEnd={() => {
                if (!isOpen && queuedProduct) {
                  setActiveProduct(queuedProduct)
                  setQueuedProduct(undefined)
                  onOpen()
                }
              }}
            >
              <Popover.Content onClickAway={() => onClose()}>
                {activeProduct && (
                  <BasketAddonItem product={activeProduct} onClose={onClose} />
                )}
              </Popover.Content>
            </Transition.Slide>

            <div className="flex flex-wrap relative z-20 bg-white">
              {enabledProducts.map((product) => (
                <Popover.Trigger
                  key={product.id}
                  onClick={() => {
                    if (isOpen) {
                      if (activeProduct?.id === product.id) {
                        setQueuedProduct(undefined)
                        onClose()
                      } else {
                        setQueuedProduct(product)
                        onClose()
                      }
                    } else {
                      setActiveProduct(product)
                    }
                  }}
                >
                  <div className="grow min-w-[50%]">
                    <BasketAddonButton className="w-full">
                      <Text variant="body-sm">{product.title}</Text>
                      <div className="w-3 h-3 inline-flex items-center justify-center">
                        {activeProduct?.id.toString() ===
                          product.id.toString() && isOpen ? (
                          <Icon.Minus width={12} height={12} />
                        ) : (
                          <Icon.Plus variant="light" width={12} height={12} />
                        )}
                      </div>
                    </BasketAddonButton>
                  </div>
                </Popover.Trigger>
              ))}
            </div>
          </div>
        </>
      )}
    </Popover>
  )
}
